import { render, staticRenderFns } from "./MergeCompanies.vue?vue&type=template&id=1c129a86&scoped=true"
import script from "./MergeCompanies.vue?vue&type=script&lang=js"
export * from "./MergeCompanies.vue?vue&type=script&lang=js"
import style0 from "./MergeCompanies.vue?vue&type=style&index=0&id=1c129a86&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c129a86",
  null
  
)

export default component.exports